import { render, staticRenderFns } from "./LoginRegisterProcessOnPublic.vue?vue&type=template&id=b318e0fa&scoped=true&"
import script from "./LoginRegisterProcessOnPublic.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterProcessOnPublic.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterProcessOnPublic.vue?vue&type=style&index=0&id=b318e0fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b318e0fa",
  null
  
)

export default component.exports